import { useMemo } from 'react';
import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function BetAmountInputButtonsV2Skeleton() {
  const Buttons: JSX.Element[] = useMemo(
    () =>
      Array.from({ length: 3 }).map((_, i) => (
        <div
          key={`bet-amount-input-skeleton-button-${i}`}
          className={skeleton.button}
        />
      )),
    [],
  );

  return (
    <div className={styles.container}>
      <div className={styles.container__row}>{Buttons}</div>
      <div className={skeleton.text} />
    </div>
  );
}
